"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SOCKET_EVENTS = exports.QUICK_REACTIONS = exports.MESSAGE_STATUS = exports.MAX_UPLOAD_FILE_SIZE_BYTES = exports.DEFAULT_LANGUAGE_LIST = exports.CONVERSATION_KIND = void 0;
// Single source of truth for the socket.io event-name strings the current
// backend speaks. Adapters translate their own transport's events into the
// handler shape below, so a future WooChat adapter can normalize differently
// named upstream events onto the same interface.
const SOCKET_EVENTS = exports.SOCKET_EVENTS = {
  // emitted by the client
  SEND_MESSAGE: "sendmessage",
  TYPING: "typing",
  STOP_TYPING: "stoptyping",
  REFRESH_AFTER_UPDATE_STATUS: "refreshafterupdatestatus",
  REPLACE_REQUIRE_RESPONSE: "replacerequireresponse",
  DELETE_CHAT_MESSAGE: "deletechatmessage",
  REACT_CHAT_MESSAGE: "reactchatmessage",
  JOIN_CHAT: "joinchat",
  LEAVE_CHAT: "leavechat",
  // listened to by the client
  INCOMING_MESSAGE: "incomingmessage",
  INCOMING_REPLACE_MESSAGE: "incomingreplacemessage",
  INCOMING_REQUIRE_RESPONSE: "incomingrequireresponse",
  AFTER_CLOSE_REQUIRE_RESPONSE: "aftercloserequireresponse",
  AFTER_DELETE_CHAT: "afterdeletechat",
  AFTER_REACT_CHAT: "afterreactchat",
  USER_TYPING: "usertyping",
  USER_STOP_TYPING: "userstoptyping"
};
const MESSAGE_STATUS = exports.MESSAGE_STATUS = {
  SENDING: "sending",
  SENT: "sent",
  FAILED: "failed"
};
const CONVERSATION_KIND = exports.CONVERSATION_KIND = {
  CONTACT: "contact",
  GROUP: "group",
  TASK: "task",
  AI: "ai"
};
const MAX_UPLOAD_FILE_SIZE_BYTES = exports.MAX_UPLOAD_FILE_SIZE_BYTES = 12500000; // 12.5MB, matches current cap

// One reaction per user per message — clicking the same emoji again clears it
// (see chatcontroller.js's reactchat), so this is a fixed quick-react set
// rather than an open emoji picker.
const QUICK_REACTIONS = exports.QUICK_REACTIONS = ["👍", "❤️", "😂"];

// Ported from lobees-web's helper/Common/CommonHelper.js `languageList`. The
// flag image paths are a public-folder convention (`/images/flagN.svg`) — any
// consuming app needs matching assets in its own `public/images/` folder;
// this package intentionally does not bundle or resolve them itself.
const DEFAULT_LANGUAGE_LIST = exports.DEFAULT_LANGUAGE_LIST = [{
  flagimageurl: "/images/flag1.svg",
  label: "EN",
  value: "en"
}, {
  flagimageurl: "/images/flag2.svg",
  label: "ES",
  value: "es"
}, {
  flagimageurl: "/images/flag3.svg",
  label: "CAT",
  value: "cat"
}];